import {
    DRIVING_LICENSE_TYPE_OPTIONS, EMPLOYMENT_STATUS_OPTIONS,
   relationshipsWithPolicyMaker,
    TITLE_OPTIONS, YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import React from "react";
import DynamicItemHeadingComponent from "@components/common/ui-elements/headings/dynamic-item-heading";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableCustomDateTimePickerBlock
    from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";
import AdditionalDriverConvictionForm from "./additional-driver-conviction-form";
import AdditionalDriverAccidentForm from "./additional-driver-accident-form";
import {PrettifiedJson} from "@utils/prettified-json";

export default function AdditionalDriverForm(
    {
        driver,
        index,
        handleAdditionalDiverPropChange,
        removeAdditionalDiverByIndex,
        handleAdditionalDriverAccidentPropChange,
        addAdditionalDriverAccident,
        removeAdditionalDriverAccident,

        handleAdditionalDriverConvictionPropChange,
        addAdditionalDriverConviction,
        removeAdditionalDriverConviction
    }
) {
   
   driver.motorAccidentsList = Array.isArray(driver.motorAccidentsList) ? driver.motorAccidentsList : [];
   driver.motoringConvictionsList = Array.isArray(driver.motoringConvictionsList) ? driver.motoringConvictionsList : [];

    return (
        <div className="additional-driver-block hidden-box row mb-3">

            <DynamicItemHeadingComponent
                text="Additional driver details"
                itemIndex={index + 1}
                onRemoveIconClick={(e) => removeAdditionalDiverByIndex(index)}
            />

            {/* Title */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Title"
                required={true}
                controlName={`additionalDrivers[${index}][title]`}
                dataBlock={`additionalDrivers.${index}.title`}
                options={TITLE_OPTIONS}
                selectedValues={driver.title}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'title', e.target.value)}
            />

            {/* Relationship to proposer/policy holder */}

            <ScrollableDropdownBlock
                controlName={`additionalDrivers[${index}][relationship]`}
                dataBlock={`additionalDrivers.${index}.relationship`}
                containerCssClass="col-12 py-3 "
                labelText="Relationship to proposer/policy holder"
                required={true}
                options={relationshipsWithPolicyMaker}
                selectedValues={driver.relationship}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'relationship', e.target.value)}
                helpText=""
            />
           
           {/*<div className="col-12 py-3">
              <PrettifiedJson
                 data={driver}
              />
           </div>*/}

            {/* First name */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 col-md-4"
                labelText="First name"
                required={true}
                controlName={`additionalDrivers[${index}][firstName]`}
                dataBlock={`additionalDrivers.${index}.firstName`}
                value={driver.firstName}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'firstName', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Last name */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 col-md-4"
                labelText="Last name"
                required={true}
                controlName={`additionalDrivers[${index}][lastName]`}
                dataBlock={`additionalDrivers.${index}.lastName`}
                value={driver.lastName}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'lastName', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />


            {/* Date of birth */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 col-md-4"
                labelText="Date of birth"
                required={true}
                controlName={`additionalDrivers[${index}][birthDate]`}
                dataBlock={`additionalDrivers.${index}.birthDate`}
                value={driver.birthDate}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'birthDate', e.target.value)}
            />

            {/* Was the driver born in UK? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Was the driver born in UK?"
                required={true}
                controlName={`additionalDrivers[${index}][isBornInUK]`}
                dataBlock={`additionalDrivers.${index}.isBornInUK`}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={driver.isBornInUK}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'isBornInUK', e.target.value)}
            />

            {driver.isBornInUK === 'No' && (


                <ScrollableCustomDateTimePickerBlock
                    containerCssClass="col-12 py-3"
                    labelText="When did you first arrive in the UK??"
                    required={driver.isBornInUK === 'No'}
                    controlName={`additionalDrivers[${index}][yearObtainingUKResidency]`}
                    dataBlock={`additionalDrivers.${index}.yearObtainingUKResidency`}
                    value={driver.yearObtainingUKResidency}
                    onChange={(e) => handleAdditionalDiverPropChange(index, 'yearObtainingUKResidency', e.target.value)}
                />

            )}


            {/* Employment status */}

            <ScrollableDropdownBlock
                controlName={`additionalDrivers[${index}][employmentStatus]`}
                dataBlock={`additionalDrivers.${index}.employmentStatus`}
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Employment status"
                required={true}
                options={EMPLOYMENT_STATUS_OPTIONS}
                selectedValues={driver.employmentStatus}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'employmentStatus', e.target.value)}
                helpText=""
            />

            {/* Occupation */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 col-md-6"
                labelText="Occupation"
                required={false}
                controlName={`additionalDrivers[${index}][occupation]`}
                dataBlock={`additionalDrivers.${index}.occupation`}
                value={driver.occupation}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'occupation', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* License type */}

            <ScrollableDropdownBlock
                controlName={`additionalDrivers[${index}][licenseType]`}
                dataBlock={`additionalDrivers.${index}.licenseType`}
                containerCssClass="col-12 py-3 col-md-6"
                labelText="License type"
                required={true}
                options={DRIVING_LICENSE_TYPE_OPTIONS}
                selectedValues={driver.licenseType}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'licenseType', e.target.value)}
                helpText=""
            />

            {/* License Number */}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 col-md-4"
                labelText="License Number"
                required={false}
                controlName={`additionalDrivers[${index}][licenseNumber]`}
                value={driver.licenseNumber}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'licenseNumber', e.target.value)}
                inputAttrs={{
                    maxLength: 50
                }}
            />*/}


            {/* When was this license obtained? */}

            <ScrollableCustomDateTimePickerBlock
                containerCssClass="col-12 py-3 col-md-6"
                labelText="When was this license obtained?"
                required={true}
                controlName={`additionalDrivers[${index}][licenseDate]`}
                dataBlock={`additionalDrivers.${index}.licenseDate`}
                value={driver.licenseDate}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'licenseDate', e.target.value)}
            />
           
           
           {/* Do you want to add license number? */}
           
           <ScrollableButtonGroupBlock
              selectedValues={driver.wantToAddLicenseNumber}
              containerCssClass="col-12 py-3"
              labelText="Do you want to add license number?"
              required={true}
              options={YES_NO_CHOICE_OPTIONS}
              
              controlName={`additionalDrivers[${index}][wantToAddLicenseNumber]`}
              dataBlock={`additionalDrivers.${index}.wantToAddLicenseNumber`}
              onChange={(e) => handleAdditionalDiverPropChange(index, 'wantToAddLicenseNumber', e.target.value)}
           />
           
           {driver.wantToAddLicenseNumber === 'Yes' && (
              
              <ScrollableTextBoxBlock
                 containerCssClass="col-12 py-3 col-md-6"
                 labelText="License number"
                 required={driver.wantToAddLicenseNumber === 'Yes'}
                 controlName={`additionalDrivers[${index}][licenseNumber]`}
                 dataBlock={`additionalDrivers.${index}.licenseNumber`}
                 onChange={(e) => handleAdditionalDiverPropChange(index, 'licenseNumber', e.target.value)}
                 asTextArea={false}
                 value={driver.licenseNumber}
                 inputAttrs={{
                    maxLength: 20
                 }}
              />
              
           )}
           

            {/* Has children? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Any children?"
                required={true}
                controlName={`additionalDrivers[${index}][hasChildren]`}
                dataBlock={`additionalDrivers.${index}.hasChildren`}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={driver.hasChildren}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'hasChildren', e.target.value)}
            />
           
           {"Yes" === driver.hasChildren && (
              <>
                 
                 {/* How many? */}
                 
                 <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 col-md-6"
                    labelText="How many?"
                    required={driver.hasChildren === 'Yes'}
                    controlName={`additionalDrivers[${index}][numberOfChildren]`}
                    dataBlock={`additionalDrivers.${index}.numberOfChildren`}
                    onChange={(e) => handleAdditionalDiverPropChange(index, 'numberOfChildren', e.target.value)}
                    asTextArea={false}
                    value={driver.numberOfChildren}
                    inputAttrs={{
                       maxLength: 2
                    }}
                 />
                 
              </>
           
           )}

            {/*
               Any motor accidents or claims in the last 5 years?
            */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Any motor accidents or claims in the last 5 years?"
                required={true}
                controlName={`additionalDrivers[${index}][motorAccidentsOrClaimsIn5Years]`}
                dataBlock={`additionalDrivers.${index}.motorAccidentsOrClaimsIn5Years`}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={driver.motorAccidentsOrClaimsIn5Years}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'motorAccidentsOrClaimsIn5Years', e.target.value)}
            />

            {driver.motorAccidentsOrClaimsIn5Years === 'Yes' && driver.motorAccidentsList.length !== 0 && (


                <div className="col-12 py-3 gap-3 d-flex flex-column">

                    {driver.motorAccidentsList?.map((accident, accidentIndex) => (

                        <AdditionalDriverAccidentForm
                            key={accidentIndex}
                            driverIndex={index}
                            accidentIndex={accidentIndex}
                            accident={accident}
                            motorAccidentsListPropName={`motorAccidentsList`}
                            handleAdditionalDriverAccidentPropChange={handleAdditionalDriverAccidentPropChange}
                            addAdditionalDriverAccident={addAdditionalDriverAccident}
                            removeAdditionalDriverAccident={removeAdditionalDriverAccident}
                        />

                    ))}

                </div>


            )}

            {driver.motorAccidentsOrClaimsIn5Years === 'Yes'
                && driver.motorAccidentsList.length === 0
                && (


                    <div className="col-12 py-3 text-center text-danger scrollable"
                         data-block={`additionalDrivers.${index}.motorAccidentsList`}>
                        No accident record submitted yet!
                    </div>


                )}

            {driver.motorAccidentsOrClaimsIn5Years === 'Yes' && (


                <div className="col-12 py-3 text-center">
                    <AddItemButtonComponent
                        text="Add Incident"
                        onClick={(e) => addAdditionalDriverAccident(index)}
                    />
                </div>


            )}

            {/*
               Any motoring convictions in the last 5 years?
            */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3"
                labelText="Any motoring convictions in the last 5 years?"
                required={true}
                controlName={`additionalDrivers[${index}][motoringConvictionsIn5Years]`}
                dataBlock={`additionalDrivers.${index}.motoringConvictionsIn5Years`}
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={driver.motoringConvictionsIn5Years}
                onChange={(e) => handleAdditionalDiverPropChange(index, 'motoringConvictionsIn5Years', e.target.value)}
            />


            {driver.motoringConvictionsIn5Years === 'Yes' && driver.motoringConvictionsList.length !== 0 && (


                <div className="col-12 py-3 gap-3 d-flex flex-column">

                    {driver.motoringConvictionsList?.map((conviction, convictionIndex) => (

                        <AdditionalDriverConvictionForm
                            key={convictionIndex}
                            conviction={conviction}
                            driverIndex={index}
                            convictionIndex={convictionIndex}
                            motorConvictionsListPropName="motoringConvictionsList"
                            handleAdditionalDriverConvictionPropChange={handleAdditionalDriverConvictionPropChange}
                            addAdditionalDriverConviction={addAdditionalDriverConviction}
                            removeAdditionalDriverConviction={removeAdditionalDriverConviction}
                        />

                    ))}

                </div>


            )}

            {driver.motoringConvictionsIn5Years === 'Yes'
                && driver.motoringConvictionsList.length === 0
                && (


                    <div className="col-12 py-3 text-center text-danger scrollable"
                         data-block={`additionalDrivers.${index}.motoringConvictionsList`}>
                        No conviction record submitted yet!
                    </div>


                )}

            {driver.motoringConvictionsIn5Years === 'Yes' && (

                <div className="col-12 py-3 text-center">
                    <AddItemButtonComponent
                        text="Add Conviction"
                        onClick={(e) => {
                            addAdditionalDriverConviction(index)
                        }}
                    />

                </div>
            )}


        </div>
    );

}